export const ImageExtension = {
  JPG: 'JPG',
} as const;
